import axios from '../config.js';
const resource = '/case';

export default {
  /**
   * Gets the case info
   * If no ID, gets all the case info available
   * @param {Number} id User ID (optional)
   */
  get(id='', no_doctor=null, status=null, page=null) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`;
    const params = new URLSearchParams();
    if (no_doctor)  params.append('no_doctor', '');
    if (status)     params.append('status', status);
    if (page)     params.append('page', page);
    return axios.get(`${resource}${id ? `/${id}`: ''}`, { params: params });
  },

  /* ------------------------------------------------- FUNCTION SEPARATOR ------------------------------------------------- */

  getByPatientId(id='', per_page=null) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    const params = new URLSearchParams();
    if (per_page)  params.append('per_page', per_page);
    return axios.get(`${resource}?patient_id=${id}`, { params: params });
  },

  /* ------------------------------------------------- FUNCTION SEPARATOR ------------------------------------------------- */

  update(id='', payload) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    
    var data = {
      _method: 'PUT',
      ...payload
    }
    
    return axios.put(`${resource}/${id}`, data);
  },

  /* ------------------------------------------------- FUNCTION SEPARATOR ------------------------------------------------- */

  create(payload) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`;

    return axios.post(`${resource}`, payload);
  },

  /* ------------------------------------------------- FUNCTION SEPARATOR ------------------------------------------------- */

  getCases(payload) {
    if (payload.params) {
      const params = new URLSearchParams();
      for (const [key, value] of Object.entries(payload.params)) {
        params.append(key, value);
      }
  
      payload.params = params;
    }

    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`;

    return axios.get(`${resource}`, payload);
  },

  /* ------------------------------------------------- FUNCTION SEPARATOR ------------------------------------------------- */

  getImageToken(case_number) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`;
    return axios.get(`${resource}/images/${case_number}`);
  },

  /* ------------------------------------------------- FUNCTION SEPARATOR ------------------------------------------------- */

  getImage(id='') {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`;
    return axios.get(`${resource}${id ? `/images/${id}`: ''}`);
  },

  /* ------------------------------------------------- FUNCTION SEPARATOR ------------------------------------------------- */

  sendPdf(consultationRequestId) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`;
    return axios.post(`${resource}/consultation/send/${consultationRequestId}`);
  },

  /* ------------------------------------------------- FUNCTION SEPARATOR ------------------------------------------------- */
  async updateCaseCallLog (payload) {
    var url = `${resource}/consultation/log/${payload.case_call_id}`;
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`;
    return axios.post(url, payload)
  }
};